import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const detailsAdapter = createEntityAdapter({})

const initialState = detailsAdapter.getInitialState()

export const detailsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        checkWhatsAppAndGetIfNew: builder.mutation({
            query: initialOrder => ({
                url: '/details',
                method: 'POST',
                body: {
                    ...initialOrder,
                },
            }),
        }),
        updateWhatsAppCount: builder.mutation({
            query: initialOrder => ({
                url: '/details/whatsapp',
                method: 'PUT',
                body: {
                    ...initialOrder,
                }
            }),
        }),
    })
        
})

export const {
    useCheckWhatsAppAndGetIfNewMutation,
    useUpdateWhatsAppCountMutation
} = detailsApiSlice